"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/DropdownParticipantsPicker/ChipInputWithSelect.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }

var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _ChipInput = require('./ChipInput'); var _ChipInput2 = _interopRequireDefault(_ChipInput);
var _SuggestionBox = require('./SuggestionBox'); var _SuggestionBox2 = _interopRequireDefault(_SuggestionBox);



























const getLengthOfAllOptions = (options) => {
  let count = 0
  Object.values(options).map(option => option.items).forEach(items => {
    if (!items) {
      return
    }
    items.forEach(item => {
      /* actions and sections count as 1 option */
      count = 'entities' in item && item.entities ? count + item.entities.length : count + 1
    })
  })
  return count
}

const EMPTY_STYLE = {}

const STYLE_KEYS = ['left', 'top', 'bottom', 'maxHeight'] 
const isSameStyle = (a, b) =>
  STYLE_KEYS.every(k => a[k] === b[k])

const ChipInputWithSelect = _react.forwardRef(({
  inputId,
  value,
  onInputChange,
  options,
  selectedOptions,
  placeholder,
  autoFocus,
  inputClassName,
  boxClassName,
  onBlur,
  onOptionSelected,
  onOptionRemoved,
  onActionSelected,
  onChipAdded,
}, ref) => {
  const [isBoxOpened, setIsBoxOpened] = _react.useState.call(void 0, false)
  const [isInputFocused, setIsInputFocused] = _react.useState.call(void 0, false)
  const [suggestionBoxStyle, setSuggestionBoxStyle] = _react.useState.call(void 0, EMPTY_STYLE)
  const inputRef = _react.useRef(null)

  _react.useImperativeHandle.call(void 0, ref, () => ({
    blur: () => {
      if (inputRef.current) {
        inputRef.current.blur()
      }
    },
    focus: () => {
      if (inputRef.current) {
        inputRef.current.focus()
      }
    },
  }), [])

  const optionsCount = getLengthOfAllOptions(options)

  // componentDidUpdate, skipping mount. It re-checks whenever an input to
  // its conditions changes.
  const isMountedRef = _react.useRef.call(void 0, false)
  _react.useLayoutEffect.call(void 0, () => {
    if (!isMountedRef.current) {
      isMountedRef.current = true
      return
    }
    if (optionsCount > 0 && !isBoxOpened && isInputFocused) {
      setIsBoxOpened(true)
    }
    if (optionsCount === 0 && isBoxOpened) {
      setIsBoxOpened(false)
    }
    if (!isBoxOpened && !isInputFocused && value.length > 0) {
      /* clear input on defocus */
      onInputChange(inputId, "")
    }
  }, [optionsCount, isBoxOpened, isInputFocused, value, onInputChange, inputId])

  // The class measured the input while rendering. Measure after the commits
  // that can open the box or move the input instead, before the browser paints.
  _react.useLayoutEffect.call(void 0, () => {
    let nextStyle = EMPTY_STYLE
    const rect = isBoxOpened ? _optionalChain([inputRef, 'access', _ => _.current, 'optionalAccess', _2 => _2.getBoundingClientRect, 'call', _3 => _3()]) : undefined
    if (rect) {
      const { top, left, height } = rect

      // If there isn't enough room to render below the input box then move it above instead
      if (window.innerHeight - top < 200) {
        nextStyle = {
          left: left,
          bottom: window.innerHeight - top + 5,
          maxHeight: top - 5,
        }
      } else {
        nextStyle = {
          left: left,
          top: top + height + 5,
          maxHeight: window.innerHeight - top - 70,
        }
      }
    }
    setSuggestionBoxStyle(prev => isSameStyle(prev, nextStyle) ? prev : nextStyle)
  }, [isBoxOpened, selectedOptions, value, optionsCount])

  const onInputFocus = () => {
    setIsInputFocused(true)
  }

  const onInputBlur = (e) => {
    if (onBlur) {
      onBlur(e)
    }
    setIsInputFocused(false)
  }

  const closeSuggestionBox = () => {
    setIsBoxOpened(false)
  }

  const handleOptionSelected = (option) => {
    inputRef.current.focus()
    if (onInputChange) {
      onInputChange(inputId, "")
    }
    if (onOptionSelected) {
      onOptionSelected(option)
    }
  }

  const handleOptionRemoved = (id) => {
    inputRef.current.focus()
    if (onOptionRemoved) {
      onOptionRemoved(id)
    }
  }

  const showSuggestionBox = (isBoxOpened || isInputFocused) && optionsCount > 0

  return (
    _react2.default.createElement(_react.Fragment, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 170}}
      , _react2.default.createElement(_ChipInput2.default, {
        autoFocus: autoFocus,
        className: inputClassName || "",
        ref: inputRef,
        onFocus: onInputFocus,
        onBlur: onInputBlur,
        inputId: inputId,
        value: value,
        placeholder: placeholder,
        onChipClose: handleOptionRemoved,
        chips: selectedOptions,
        onChange: onInputChange,
        onChipAdded: onChipAdded, __self: this, __source: {fileName: _jsxFileName, lineNumber: 171}}
        )
      , _react2.default.createElement(_SuggestionBox2.default, {
        showTabs: true,
        options: options,
        style: suggestionBoxStyle,
        className: boxClassName || "",
        open: showSuggestionBox,
        onOptionSelected: handleOptionSelected,
        onActionSelected: onActionSelected,
        onClickedOutsideBox: closeSuggestionBox, __self: this, __source: {fileName: _jsxFileName, lineNumber: 185}}
        )
    )
  )
})
ChipInputWithSelect.displayName = 'ChipInputWithSelect'

exports. default = ChipInputWithSelect
